export const issuesDropdown = [
	"Relationship Issue (friend, family, or partner)",
	"Financial Stress",
	"Health issue (self or other)",
	"Work Stress",
	"Study Stress",
	"Job Loss",
	"Personal Mental Health Issue",
	"Lack of Support or Resources",
	"Traumatic or Stressful Live Event",
	"Loneliness/Isolation",
	"Caring for another",
	"Parenting",
	"Recent or upcoming major change or decision",
	"Grief or loss",
	"Bullying",
	"Struggling with Identity",
	"Pressure to perform",
	"Financial Coaching",
	"Others"
]
